import { createSelector } from 'reselect';
import { FileUploadStatus } from '../enums';
import { getFileInfoState } from './getFileInfoState';
export const getFirstReadyFile = createSelector([getFileInfoState], state => {
    for (let index = 0; index < state.allIds.length; index++) {
        const fileInfo = state.byId[state.allIds[index]];
        if (fileInfo.uploadStatus === FileUploadStatus.READY) {
            return fileInfo;
        }
    }
    return null;
});
//# sourceMappingURL=getFirstReadyFile.js.map